/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RecordingManualChangesResponseFieldsContributionsItemsInnerChanges } from './RecordingManualChangesResponseFieldsContributionsItemsInnerChanges';
import {
    RecordingManualChangesResponseFieldsContributionsItemsInnerChangesFromJSON,
    RecordingManualChangesResponseFieldsContributionsItemsInnerChangesFromJSONTyped,
    RecordingManualChangesResponseFieldsContributionsItemsInnerChangesToJSON,
} from './RecordingManualChangesResponseFieldsContributionsItemsInnerChanges';

/**
 * 
 * @export
 * @interface RecordingManualChangesResponseFieldsContributionsItemsInner
 */
export interface RecordingManualChangesResponseFieldsContributionsItemsInner {
    /**
     * 
     * @type {string}
     * @memberof RecordingManualChangesResponseFieldsContributionsItemsInner
     */
    op: string;
    /**
     * 
     * @type {string}
     * @memberof RecordingManualChangesResponseFieldsContributionsItemsInner
     */
    role: string;
    /**
     * 
     * @type {string}
     * @memberof RecordingManualChangesResponseFieldsContributionsItemsInner
     */
    dataCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordingManualChangesResponseFieldsContributionsItemsInner
     */
    sourceUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecordingManualChangesResponseFieldsContributionsItemsInner
     */
    notes?: string | null;
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsContributionsItemsInnerChanges}
     * @memberof RecordingManualChangesResponseFieldsContributionsItemsInner
     */
    changes?: RecordingManualChangesResponseFieldsContributionsItemsInnerChanges;
}

/**
 * Check if a given object implements the RecordingManualChangesResponseFieldsContributionsItemsInner interface.
 */
export function instanceOfRecordingManualChangesResponseFieldsContributionsItemsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "role" in value;

    return isInstance;
}

export function RecordingManualChangesResponseFieldsContributionsItemsInnerFromJSON(json: any): RecordingManualChangesResponseFieldsContributionsItemsInner {
    return RecordingManualChangesResponseFieldsContributionsItemsInnerFromJSONTyped(json, false);
}

export function RecordingManualChangesResponseFieldsContributionsItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordingManualChangesResponseFieldsContributionsItemsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'op': json['op'],
        'role': json['role'],
        'dataCategory': !exists(json, 'data_category') ? undefined : json['data_category'],
        'sourceUrl': !exists(json, 'source_url') ? undefined : json['source_url'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'changes': !exists(json, 'changes') ? undefined : RecordingManualChangesResponseFieldsContributionsItemsInnerChangesFromJSON(json['changes']),
    };
}

export function RecordingManualChangesResponseFieldsContributionsItemsInnerToJSON(value?: RecordingManualChangesResponseFieldsContributionsItemsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'op': value.op,
        'role': value.role,
        'data_category': value.dataCategory,
        'source_url': value.sourceUrl,
        'notes': value.notes,
        'changes': RecordingManualChangesResponseFieldsContributionsItemsInnerChangesToJSON(value.changes),
    };
}

